import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'
import { CreateCheckoutToken, CreateCheckoutTokenVariables } from './__generated__/CreateCheckoutToken'

const CREATE_CHECKOUT_TOKEN_MUTATION = gql`
  mutation CreateCheckoutToken($boardId: String!, $boardTitle: String) {
    createCheckoutTokenV2(boardId: $boardId, boardTitle: $boardTitle) {
      ... on CheckoutTokenV2 {
        token
        url
      }
      ... on CheckoutTokenErrorV2 {
        error
        type
      }
    }
  }
`

export const useCreateCheckoutToken = () => {
  return useMutation<CreateCheckoutToken, CreateCheckoutTokenVariables>(CREATE_CHECKOUT_TOKEN_MUTATION)
}
